export type StructureColumnType = "string" | "date" | "float" | "int" | "bool" | "long string"

export class StructureColumn {
	public name:string = "newColumn";
	public type:StructureColumnType = "string"
	public translatedName:string = "Nieuw kolom"

	public constructor(data?:any){
		if (!data) return;
		this.name = data.name;
		this.type = data.type;
		this.translatedName = data.translatedName;
	}

	public getJSON(){
		return {
			name: this.name,
			type: this.type,
			translatedName: this.translatedName
		};
	}
}